var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-clock",class:_vm.isTimeUp ? 'text-danger' : ''},[_vm._v(" "+_vm._s(_vm.formatTime(_vm.increasingMinutes))+":"+_vm._s(_vm.formatTime(_vm.increasingSeconds))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }